<template>
  <a class="link" :class="objectClass" @click="emitClick"><slot /></a>
</template>

<script>
export default {
  props: {
    /**
     * set variant: `primary` `inline`
     * is required if variants are set dynamically
     */
    variant: {
      required: false,
      type: String,
      default: "primary",
      validator: (val) => {
        return ["primary", "inline"].indexOf(val) !== -1;
      },
    },

    /**
     * primary variant, this prop override the variant prop
     */
    primary: {
      required: false,
      type: Boolean,
      default: undefined,
    },

    /**
     * inline variant, this prop override the variant prop
     */
    inline: {
      required: false,
      type: Boolean,
      default: undefined,
    },

    /**
     * set arrow type: `default`, `left`, `up`, `down`, `none`
     * this must only be set for `variant="primary"`
     */
    arrow: {
      required: false,
      type: String,
      default: "default",
      validator: (val) => {
        return ["default", "left", "up", "down", "none"].indexOf(val) !== -1;
      },
    },

    isExternal: {
      required: false,
      type: Boolean,
      default: false,
    },

    isDisabled: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  computed: {
    compVariant() {
      if (this.primary) return "primary";
      if (this.inline) return "inline";
      return this.variant;
    },

    objectClass() {
      return {
        "link--primary": this.compVariant === "primary" && this.arrow !== "up" && this.arrow !== "down",
        "link--inline": this.compVariant === "inline",
        "link--external": this.isExternal,
        "link--left-arrow": this.compVariant === "primary" && this.arrow === "left",
        "link--read-more": this.compVariant === "primary" && this.arrow === "down",
        "link--read-less": this.arrow === "up",
        "link--no-arrow": this.arrow === "none",
        "is-disabled": this.isDisabled,
      };
    },
  },

  methods: {
    emitClick(e) {
      if (!this.isDisabled) {
        this.$emit("click", e);
      }
    },
  },
};
</script>
